import { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import routes from './index';
import RenderRoute from './RenderRoute';

const AppRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (['/home', '/home/', '/home/index.php'].includes(location?.pathname)) navigate('/');
  }, [location]);

  return (
    <Routes>
      <Route path='/'>
        {routes.map(
          (
            { index = false, path, component: Component, isPrivate, title, permission = '' },
            key,
          ) => (
            <Route
              key={key}
              index={index}
              path={path}
              element={
                <RenderRoute helmetTitle={title} routeId={permission} isPrivate={isPrivate}>
                  <Component />
                </RenderRoute>
              }
            />
          ),
        )}
      </Route>
    </Routes>
  );
};

export default AppRouter;
